import React, { Component } from 'react';
import '../../styles/common.scss';
import './index.scss';
import * as API from '../../configuration/apiconfig';
import Loader from '../loader';
import MovieInfo from '../../components/MovieInfo/MovieInfo';
import { ReactComponent as IconInfo } from '../../assets/images/icons/iconInfo.svg';
import { ReactComponent as AlertIcon } from '../../assets/images/info-icon.svg';
import Header from '../../components/Header';
import CustomModal from '../../components/CustomModal';
import PurchaseFooter from '../../components/Footer';

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      showDateActiveState: 0,
      filmsData: {},
      datesData: [],
      cinemasData: [],
      experienceData: [],
      showTimeData: [],
      // filteredExperiencesForSelectedShowDate: []
      filteredExperiences: [],
      filteredShowtimes: [],
      selectedExp: {},
      selectedMultiExp: [],
      expandedExperiences: new Set(),
      selectedSessionID: '',
      consumerAdviceModalSH: false,
      consumerAdviceData: window.constant.CONSUMER_ADVICE,
      futureDateCaution: false,
      getFormats: [],
    };
  }

  componentDidMount = () => {
    window.winvar = this;
    this.getFilms();
    localStorage.removeItem('sesstionid');
    localStorage.removeItem('sessionExpiredRedirectUrl');
    localStorage.removeItem('endTimeInSecs');
    localStorage.removeItem('BookingCountdown');
    // console.log(this.checkIfRatingMessageHasToBeShown("R"));
    // console.log(this.checkIfRatingMessageHasToBeShown("18A"));
    // console.log(this.checkIfRatingMessageHasToBeShown("PG"));
    if (localStorage.getItem('orderId') != null && localStorage.getItem('giftCardSwipeInit') != null) {
      var orderDetails = JSON.parse(localStorage.getItem('orderId'));
      if (orderDetails?.id) {
        localStorage.removeItem('giftCardSwipeInit');
        window.callbackObj.callAbortTransaction(orderDetails.id, 'failure', 'Sorry', 'Swipe cancelled');
      }

      this.deleteOrder();
      localStorage.removeItem('orderId');
    }
    localStorage.removeItem('orderId');
    localStorage.removeItem('selectedSeats');
    localStorage.removeItem('cartData');
  };

  AbortTransactionResponse = response => {
    // This is dot net function
    console.log(response, 'Swipe card abort response--showtime page');
  };

  GiftCardSwipeResponse = response => {
    // This is dot net function
    console.log(response, 'GiftCardSwipeResponse--showtime page');
  };

  deleteOrder = () => {
    var orderDetails = JSON.parse(localStorage.getItem('orderId'));
    if (orderDetails?.id) {
      API.callEndpoint('DELETE', 'Bearer', `/order/v2/orders/${orderDetails.id}`)
        .then(response => {
          console.log(response);
        })
        .catch(ex => {
          console.log(ex.error);
        });
    }
  };

  getFilms = async () => {
    this.setState(
      {
        loader: true,
      },
      () => {
        const urlParams = new URLSearchParams(window.location.search);
        const getMovieName = urlParams.get('title');
        // const films = await API.callEndpoint("GET", "Bearer", `/cms/v2/films?urlsafetitle=${getMovieName}`);
        API.callEndpoint('GET', 'Bearer', `/cms/v2/films?urlsafetitle=${getMovieName}`).then(response => {
          this.setState(
            {
              filmsData: response.data[0],
            },
            () => {
              var ratingDescriptionFirstLineIndex = this.state.consumerAdviceData.descriptions.findIndex(x => x.rating == this.state.filmsData.rating);
              if (ratingDescriptionFirstLineIndex != -1) {
                var description = this.state.consumerAdviceData.description;
                description.unshift(this.state.consumerAdviceData.descriptions[ratingDescriptionFirstLineIndex].description);
                this.setState({
                  consumerAdviceData: { ...this.state.consumerAdviceData, description },
                });
              }
              this.getShowDate();
            }
          );
        });
      }
    );
  };

  getShowDate = () => {
    var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
    API.callEndpoint('GET', 'Bearer', `/cms/v2/distinctshowdates?filmid=${this.state.filmsData.id}&cinemaid=${getCinemaIdFromLocalstorage}`).then(response => {
      this.setState(
        {
          datesData: response.data,
        },
        () => {
          // // // // // this.getCinemas(); // No need for CinemasData.
          this.allExperiences();
          if (window.constant.SHOW_FORMATS_ON_SHOWTIME === 'true') {
            this.getFormats();
          }
        }
      );
    });
  };

  getCinemas = () => {
    API.callEndpoint('GET', 'Bearer', '/cms/v2/cinemas').then(response => {
      this.setState(
        {
          cinemasData: response.data,
        },
        () => {
          this.allExperiences();
          if (window.constant.SHOW_FORMATS_ON_SHOWTIME === 'true') {
            this.getFormats();
          }
        }
      );
    });
  };

  allExperiences = async () => {
    API.callEndpoint('GET', 'Bearer', '/cms/v2/experiences').then(response => {
      this.setState(
        {
          experienceData: response.data,
        },
        () => {
          // this.state.datesData.length > 0 && this.showtimesLoadOnClick(this.state.datesData[0].showdate.split("T")[0]);
          if (this.state.datesData.length > 0) {
            this.showtimesLoadOnClick(this.state.datesData[0].showdate.split('T')[0]);
            this.handleFutureDateSelection(this.state.datesData[0].showdate.split('T')[0]);
          }
        }
      );
    });
  };

  getFormats = async () => {
    const getFormatsData = await API.callEndpoint('GET', 'Bearer', `/cms/v2/attributes`)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log('error', err);
      });

    this.setState({
      getFormats: getFormatsData?.length > 0 ? getFormatsData : [],
    });
  };

  showtimesLoadOnClick = async selectedDate => {
    var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
    this.setState(
      {
        loader: true,
      },
      () => {
        API.callEndpoint('GET', 'Bearer', `/cms/v2/${this.state.filmsData.id}/showtimes?showdate=${selectedDate}&cinemaid=${getCinemaIdFromLocalstorage}`).then(response => {
          this.setState(
            {
              showTimeData: response.data,
              loader: false,
            },
            () => {
              this.filterExperiencesFromShowTime();
              this.filterShowTimeFromExperiences();
            }
          );
        });
      }
    );
  };

  filterExperiencesFromShowTime = async () => {
    var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
    var getExpObj = this.state.showTimeData.filter(x => x.cinemaid == getCinemaIdFromLocalstorage);
    // Only get experiences from single-experience showtimes
    var singleExpShowtimes = getExpObj.filter(showtime => showtime.experiences.length === 1);
    const experiences = this.state.experienceData.filter(exp => {
      return singleExpShowtimes.find(data => data.experiences[0] === exp.id);
    });
    this.setState({
      filteredExperiences: experiences,
    });
  };

  filterShowTimeFromExperiences = () => {
    var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
    var getShowtimeObj = this.state.showTimeData.filter(x => x.cinemaid == getCinemaIdFromLocalstorage);
    // Only keep single-experience showtimes in filteredShowtimes for the main experience groups
    var singleExpShowtimes = getShowtimeObj.filter(showtime => showtime.experiences.length === 1);
    this.setState({
      filteredShowtimes: singleExpShowtimes,
    });
  };

  // moviesPosterRender = () => {
  //   var tempFilmsData = this.state.filmsData;
  //   var renderTags = "";
  //   {
  //     renderTags =
  //       Object.keys(tempFilmsData).length > 0 ? (
  //         <div className="movie-detail-wrap">
  //           {tempFilmsData.images.length > 0 ? (
  //             <img
  //               src={
  //                 tempFilmsData.images.find((x) => x.code === "x280y420")
  //                   .imageurl
  //               }
  //               alt={tempFilmsData.title}
  //               className="poster-img"
  //             />
  //           ) : null}
  //           {/* <img src={Poster} alt={tempFilmsData.title} className="poster-img" /> */}

  //           <aside className="movie-detail">
  //             <h1 className="movie-title">{tempFilmsData.title}</h1>
  //             <div className="movie-desc">
  //               <div>
  //                 <span>{tempFilmsData.rating}</span>
  //                 {tempFilmsData.genres.length > 0 ? (
  //                   <span>
  //                     {tempFilmsData.genres.map((actionData, index) => {
  //                       return (
  //                         <>
  //                           {actionData}
  //                           {tempFilmsData.genres.length - 1 == index
  //                             ? ""
  //                             : ", "}
  //                         </>
  //                       );
  //                     })}
  //                   </span>
  //                 ) : null}
  //                 {tempFilmsData.language && (
  //                   <span>Language - {tempFilmsData.language}</span>
  //                 )}
  //                 <span>{tempFilmsData.runtime} min</span>
  //                 {tempFilmsData.subtitle && (
  //                   <span>Subtitle - {tempFilmsData.subtitle}</span>
  //                 )}
  //               </div>
  //             </div>
  //             {tempFilmsData.cast ? (
  //               <p className="movie-cast">
  //                 <span className="font-bold">Cast</span>
  //                 {tempFilmsData.cast}
  //               </p>
  //             ) : null}
  //             {tempFilmsData.synopsis ? (
  //               <p className="movie-synopsis">
  //                 <span className="font-bold">Synopsis</span>
  //                 {tempFilmsData.synopsis}
  //               </p>
  //             ) : null}
  //           </aside>
  //         </div>
  //       ) : null;
  //   }
  //   return renderTags;
  // };

  datesRender = () => {
    var tempDatesData = this.state.datesData;
    var datesTagsRender = '';
    {
      datesTagsRender =
        tempDatesData.length > 0
          ? tempDatesData.map((dateDatas, index) => {
            return (
              <li onClick={event => this.showDatesOnClick(event, dateDatas.showdate.split('T')[0], index)} className={`movie-date-wrap ${index == this.state.showDateActiveState ? 'today' : ''}`}>
                {this.populateDataString(dateDatas.showdate, dateDatas.day, dateDatas.tz)}
              </li>
            );
          })
          : null;
    }
    return datesTagsRender;
  };

  populateDataString = (showDateItem, dayName, timeZone) => {
    // console.log("showDateItem - " + showDateItem);
    // var showdateStr = showDateItem.split("T")[0];
    // showdateStr = showdateStr.split("-").join("");
    // console.log("showdateStr - >" + showdateStr);
    // var currentDates = new Date().toJSON();
    // console.log("currentDates");
    // console.log(new Date());
    // currentDates = currentDates.split("T")[0];
    // var dayStr = this.getMonthDays(showDateItem, "monthField") + " " + showDateItem.split("T")[0].split("-")[2];
    // return (
    //   <>
    //     <div className="movie-date">{showdateStr.toString() === currentDates.toString() ? "Today" : dayStr}</div>
    //     <div className="movie-day">{showdateStr.toString() === currentDates.toString() ? dayStr : this.getMonthDays(showDateItem, "dayField")}</div>
    //   </>
    // );

    var showDate = showDateItem.split('T')[0];
    var currentDates = new Date().toLocaleString('en-US', { timeZone: timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).split(',')[0].split('/');
    var currentDateString = currentDates[2] + '-' + currentDates[0] + '-' + currentDates[1];
    var dayStr = this.getMonthDays(showDateItem, 'monthField') + ' ' + showDateItem.split('T')[0].split('-')[2];
    // // // // // // // // // // var dayName = new Date(showDateItem).toString().split(" ")[0];
    return (
      <>
        <div className="movie-date">{showDate === currentDateString ? 'Today' : dayStr}</div>
        <div className="movie-day">{dayName.slice(0, 3)}</div>
      </>
    );
  };

  getMonthInNumber = monthInString => {
    var monthNameArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var monthNumber = monthNameArray.indexOf(monthInString) + 1;
    return monthNumber < 10 ? '0' + monthNumber : monthNumber;
  };
  getMonthDays = (getShowDate, getFields) => {
    if (getFields === 'monthField') {
      var getMonth = getShowDate.split('T')[0].split('-')[1];
      var monthNameArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
      return monthNameArray[getMonth - 1];
    } else if (getFields === 'dayField') {
      var dayName = new Date(getShowDate);
      var weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      return weekday[dayName.getDay()];
    }
  };

  showDatesOnClick = (event, selectedDate, getIndex) => {
    var currentEle = event.currentTarget;
    setTimeout(() => {
      currentEle &&
        currentEle.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
    }, 250);
    this.setState(
      {
        showDateActiveState: getIndex,
      },
      () => {
        this.handleFutureDateSelection(selectedDate);
        this.showtimesLoadOnClick(selectedDate);
      }
    );
  };

  handleFutureDateSelection = selectedDate => {
    // Caution Message - Selecting future date.
    // console.log("handleFutureDateSelection()");
    // console.log("handleFutureDateSelection() > selectedDate", selectedDate);
    var currentDates = new Date().toJSON();
    // console.log("handleFutureDateSelection() > currentDates", currentDates);
    // var currentDates = moment().tz(tz);
    // currentDates = currentDates.format().split("T")[0];
    currentDates = currentDates.split('T')[0];
    var currentDateArr = currentDates.split('-');
    var currentDatestr = parseInt(currentDateArr.join(''));
    var selectedFilmShowDateArr = selectedDate.split('-');
    var selectedFilmShowDateStr = parseInt(selectedFilmShowDateArr.join(''));
    // console.log("handleFutureDateSelection() > currentDatestr", currentDatestr);
    // console.log("handleFutureDateSelection() > selectedFilmShowDateStr", selectedFilmShowDateStr);
    this.setState({
      futureDateCaution: selectedFilmShowDateStr > currentDatestr ? true : false,
    });
  };

  handleExpModal = data => {
    let selectedExpImageUrl = data.images.filter(x => x.code === 'x748y475')[0]?.imageurl;
    let selectedExpLogoUrl = data.images.filter((exp) => exp.code === 'x330y50' && !exp.description?.toLowerCase().includes("right"))[0]?.imageurl;
    this.setState({
      selectedExp: {
        ...data,
        expImageUrl: selectedExpImageUrl,
        expLogoUrl: selectedExpLogoUrl,
      }, // Assuming experiences are in the data object
      selectedMultiExp: [],
    });
  };

  handleMultiExpModal = experienceIds => {
    console.log(experienceIds, "handleMultiExpModal -> experienceIds");
    const multiExpData = this.state.experienceData
      .filter(exp => experienceIds.includes(exp.id))
      .map(data => {
        let selectedExpImageUrl = data.images.filter(x => x.code === 'x748y475')[0]?.imageurl;
        let selectedExpLogoUrl = data.images.filter(x => x.code === 'x330y50')[0]?.imageurl;
        return {
          ...data,
          expImageUrl: selectedExpImageUrl,
          expLogoUrl: selectedExpLogoUrl,
        };
      });
    console.log(multiExpData, "multiExpData");
    this.setState({
      selectedMultiExp: multiExpData,
      selectedExp: {},
      expandedExperiences: new Set(),
    });
  };

  toggleExpanded = (experienceId) => {
    const newExpandedSet = new Set(this.state.expandedExperiences);
    if (newExpandedSet.has(experienceId)) {
      newExpandedSet.delete(experienceId);
    } else {
      newExpandedSet.add(experienceId);
    }
    this.setState({ expandedExperiences: newExpandedSet });
  };

  checkIfRatingMessageHasToBeShown = rating => {
    var ratingsArray = this.state.consumerAdviceData.descriptions.map(item => item.rating);
    return ratingsArray.includes(rating);
  };

  getSingleExperienceShowtimes = () => {
    var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
    var getShowtimeObj = this.state.showTimeData.filter(x => x.cinemaid === getCinemaIdFromLocalstorage);
    return getShowtimeObj.filter(showtime => showtime.experiences.length === 1);
  };

  getMultiExperienceShowtimes = () => {
    var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
    var getShowtimeObj = this.state.showTimeData.filter(x => x.cinemaid === getCinemaIdFromLocalstorage);
    return getShowtimeObj.filter(showtime => showtime.experiences.length > 1);
  };
  renderShowtimeItem = (showTimeData) => {
    let ticketStatus = showTimeData.ticketstatus;
    let showtimeClass =
      ticketStatus === 'Available'
        ? 'showtimeAvailable'
        : ticketStatus === 'Fast Filling'
          ? 'showtimeFastFilling'
          : ticketStatus === 'Sold Out'
            ? 'showtimeSold'
            : ticketStatus === 'Disabled'
              ? 'showtimeDisabled'
              : '';
    let checkFormat = showTimeData.formats.length > 0 ? this.state.getFormats.filter(format => format.id === showTimeData.formats[0]) : '';
    return (
      <li className={`play-date-wrap ${showtimeClass}`}>
        {this.checkIfRatingMessageHasToBeShown(this.state.filmsData.rating) ? (
          <a
            className="play-time"
            href="javascript:;"
            onClick={() => {
              this.setState(
                {
                  selectedSessionID: showTimeData.id,
                  consumerAdviceModalSH: true,
                },
                () => {
                  localStorage.setItem('sesstionid', this.state.selectedSessionID);
                }
              );
            }}
          >
            {this.formatShowTime(showTimeData.showtime)}
          </a>
        ) : (
          <a className={`play-time ${this.state.getFormats.length > 0 ? 'add-formats' : ''}`} href="javascript:;" onClick={() => this.handleRredirectToSeatLayoutPage(showTimeData.id)}>
            <span>{this.formatShowTime(showTimeData.showtime)}</span>
            {checkFormat.length > 0 && <span className="format">{checkFormat[0].description}</span>}
          </a>
        )}
        {(ticketStatus === 'Fast Filling' || ticketStatus === 'Sold Out') && <span>{ticketStatus}</span>}
      </li>
    );
  };

  showTimesRender = () => {
    var tempFilteredShowtimes = this.state.filteredShowtimes;
    var tempFilteredExperiences = this.state.filteredExperiences;
    var multiExperienceShowtimes = this.getMultiExperienceShowtimes();
    var showTimeTagsRender = '';

    // Render single-experience showtimes grouped by experience
    var singleExpSection = '';
    if (tempFilteredExperiences.length > 0 && tempFilteredShowtimes.length > 0) {
      singleExpSection = tempFilteredExperiences.map(expData => {
        return (
          <section className="play-wrap" key={`exp-${expData.id}`}>
            <div className="play-icon-wrap">
              <h2>{expData.name}</h2>
              <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#showTimeModal" onClick={() => this.handleExpModal(expData)}>
                {/* <img src={IconInfo} alt="Info" /> */}
                <IconInfo />
              </a>
            </div>
            <ul>
              {tempFilteredShowtimes.map(showTimeData => {
                return (
                  showTimeData.experiences[0] === expData.id && (
                    <React.Fragment key={showTimeData.id}>{this.renderShowtimeItem(showTimeData)}</React.Fragment>
                  )
                );
              })}
            </ul>
          </section>
        );
      });
    }

    // Render multi-experience showtimes in a separate section
    var multiExpSection = '';
    if (multiExperienceShowtimes.length > 0) {
      // Group multi-experience showtimes by their experience combination
      const groupedByExperience = {};
      multiExperienceShowtimes.forEach(showtime => {
        // Create a unique key for each experience combination
        const experienceKey = showtime.experiences.sort().join(',');
        if (!groupedByExperience[experienceKey]) {
          groupedByExperience[experienceKey] = [];
        }
        groupedByExperience[experienceKey].push(showtime);
      });

      // Render each experience combination as a separate section
      multiExpSection = Object.entries(groupedByExperience).map(([experienceKey, showtimes]) => {
        let experienceNames = this.state.experienceData
          .filter(exp => experienceKey.split(',').includes(exp.id.toString()))
          .map(exp => exp.name)
          .join(', ');
        let experienceIds = experienceKey.split(',');

        return (
          <section className="play-wrap multi-experience-wrap" key={experienceKey}>
            <div className="play-icon-wrap">
              <h2>{experienceNames}</h2>
              <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#showTimeModal" onClick={() => this.handleMultiExpModal(experienceIds)}>
                <IconInfo />
              </a>
            </div>
            <ul>
              {showtimes.map(showTimeData => {
                return (
                  <li key={showTimeData.id} className="play-date-wrap">
                    {this.renderShowtimeItem(showTimeData)}
                  </li>
                );
              })}
            </ul>
          </section>
        );
      });
    }

    // Combine sections
    if ((tempFilteredExperiences.length > 0 && tempFilteredShowtimes.length > 0) || multiExperienceShowtimes.length > 0) {
      showTimeTagsRender = (
        <>
          {singleExpSection}
          {multiExpSection}
        </>
      );
    } else {
      if (!this.state.loader) {
        showTimeTagsRender = (
          <aside className="showtime-not">
            <p>Showtimes are coming soon! Tickets for this film are not yet available.</p>
          </aside>
        );
      }
    }
    return showTimeTagsRender;
  };

  formatShowTime = time => {
    var actualShowTime = time.split('T')[1].split(':');
    var hours = actualShowTime[0];
    hours = hours > 12 ? hours - 12 : hours;
    hours = ('0' + hours).slice(-2);

    var minutes = actualShowTime[1];
    minutes = ('0' + minutes).slice(-2);

    var meridian = actualShowTime[0] >= 12 ? 'PM' : 'AM';
    return hours + ':' + minutes + ' ' + meridian;
  };

  handleRredirectToSeatLayoutPage = sessionid => {
    this.setState(
      {
        selectedSessionID: sessionid,
      },
      () => {
        // window.location.href = `/seatlayout?sessionid=${this.state.selectedSessionID}`;
        localStorage.setItem('sesstionid', this.state.selectedSessionID);
        window.location.href = `/login`;
      }
    );
  };

  iAgreeBtnClick = () => {
    window.location.href = `/login`;
  };

  cancelBtnClick = () => {
    this.setState({ consumerAdviceModalSH: false });
  };

  backBtnClick = () => {
    console.log('backBtnClick');

    window.location = '/movies';
  };

  render() {
    return (
      <>
        <Loader loader={this.state.loader} />
        <section className="showtime-container">
          <Header logo={true} homeIcon={true} timer={false} />
          {/* <section className="banner-wrap">
            <img src={MaskIcon} alt="Background Poster" className="bg-banner" />
            {this.moviesPosterRender()}
          </section> */}
          <MovieInfo filmsData={this.state.filmsData} />
          <section className="time-wrap">
            <ul id="date-list">{this.datesRender()}</ul>
            {this.state.futureDateCaution ? (
              <section className="futureDateCaution">
                <AlertIcon />
                <p>Caution: The selected date is in the future.</p>
              </section>
            ) : (
              ''
            )}
          </section>
          <section className="show-times-sec">{this.showTimesRender()}</section>
          <PurchaseFooter
            fnbDataForTicketSummary={[]}
            ticketsDataForTicketSummary={[]}
            ticketsTaxValue={0}
            fnbTaxValue={0}
            removeItemFromCart={false}
            incDecItem={false}
            backBtnClick={this.backBtnClick}
            nextBtnClick={this.continueNextStep}
            nextBtnText=""
            nextBtnDisable={true}
          ></PurchaseFooter>
          {/* <section className="footer">
            <Link to={`/movies`} title="Back" className="back-link">
              Back
            </Link>
          </section> */}
        </section>
        <div className="modal fade showtime-modal" id="showTimeModal" tabindex="-1" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <a href="javascript:;" className="modal-close" data-bs-dismiss="modal" aria-label="Close"></a>
              <div className="modal-body">
                {this.state.selectedMultiExp.length > 0 ? (
                  // Display multiple experiences
                  this.state.selectedMultiExp.map((exp, index) => {
                    const isExpanded = this.state.expandedExperiences.has(exp.id);
                    const maxCharsFor3Lines = 100;
                    const isLongDescription = exp.description && exp.description.length > maxCharsFor3Lines;
                    const displayText = isExpanded ? exp.description : exp.description?.substring(0, maxCharsFor3Lines) + (isLongDescription ? '...' : '');

                    return (
                      <div key={exp.id}>
                        <div className="movie-info-modal">
                          {exp.expLogoUrl ? (
                            <div className="modal-banner">
                              <img src={exp.expLogoUrl} alt="Experience Logo" className="exp-icon" />
                            </div>
                          ) : (
                            <p className="experinceHeading">{exp.name}</p>
                          )}
                          <p className="movie-info-desc">
                            {displayText}
                            {isLongDescription && (
                              <button
                                onClick={() => this.toggleExpanded(exp.id)}
                                className='movie-info-desc-expand-btn'
                              >
                                {isExpanded ? ' Show Less' : ' More'}
                              </button>
                            )}
                          </p>
                        </div>
                        {index < this.state.selectedMultiExp.length - 1 && <hr style={{ margin: 0 }} />}
                      </div>
                    );
                  })
                ) : (
                  // Display single experience
                  <>
                    <div className="movie-info-modal">
                      {this.state.selectedExp.expLogoUrl ? (
                        <div className="modal-banner">
                          <img src={this.state.selectedExp.expLogoUrl} alt="Experience Logo" className="exp-icon" />
                        </div>
                      ) : (
                        <p className="experinceHeading">{this.state.selectedExp.name}</p>
                      )}
                      <p className="movie-info-desc">{this.state.selectedExp.description}</p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <CustomModal
          show={this.state.consumerAdviceModalSH}
          handleClose={() => {
            this.setState({ consumerAdviceModalSH: true, alertData: {} });
          }}
          title={this.state.consumerAdviceData.title}
          descriptionsList={this.state.consumerAdviceData.description}
          customClasses="consumber-advice-popup"
          icon={false}
          iconWidth={'auto'}
          iconHeight={'0'}
          showCancelBtn={true}
          cancelBtnText="CANCEL"
          showConfirmBtn={true}
          confirmBtnText="I AGREE"
          onConfirm={() => {
            this.iAgreeBtnClick();
          }}
          onCancel={() => {
            this.cancelBtnClick();
          }}
        />
      </>
    );
  }
}

export default index;
